import { call, CommonErrorMessages } from '../@';
import { forceUpdateUserData } from '../auth/user-change';

export default async function deleteProfilePicture() {
	const res = await call('profilePicture-remove', {});
	if (!res?.ok) throw new Error(CommonErrorMessages.unknownResponse);
	await forceUpdateUserData();
}
